export default function usePreloadImage (srcSet, webpSrcSet, sizes) {
  const supportsWebp = !!(() => document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0)
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => { resolve(image) })
    image.addEventListener('error', err => reject(err))
    image.sizes = sizes
    if (supportsWebp) {
      image.srcset = webpSrcSet
    } else {
      image.srcset = srcSet
    }
  })
}